import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { Button } from '@wds/button';
import uninstallAppMutation from '../../../components/RemoveApp/remove-app.graphql';
import UninstallConfirmModal from './UninstallConfirmModal';

import useStyles from '../styles';

const UninstallButton = ({ appId, onSuccess, onClose, color, stretched }) => {
  const { uninstallButton } = useStyles();
  const [confirmDialogVisible, setConfirmDialogVisible] = useState(false);

  const [uninstallApp, { loading }] = useMutation(uninstallAppMutation, {
    onCompleted: () => {
      setConfirmDialogVisible(false);
      onSuccess();
    },
  });

  const handleCancel = () => {
    setConfirmDialogVisible(false);
    onClose();
  };

  const handleConfirm = () => {
    uninstallApp({
      variables: { input: { appId } },
    });
  };

  return (
    <>
      <span className={!stretched ? uninstallButton : ''}>
        <Button
          onClick={() => setConfirmDialogVisible(true)}
          data-testid="UninstallButton"
          color={color}
          stretched={stretched}
        >
          Uninstall
        </Button>
      </span>
      <UninstallConfirmModal
        showModal={confirmDialogVisible}
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        loading={loading}
      />
    </>
  );
};

UninstallButton.propTypes = {
  appId: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  color: PropTypes.string,
  stretched: PropTypes.bool,
};

UninstallButton.defaultProps = {
  onClose: () => {},
  onSuccess: () => {},
  color: 'alt',
  stretched: false,
};

export default UninstallButton;
